import React from 'react';
import { twMerge } from 'tailwind-merge';
// Simple wrapper for main user prompt in conversation.
// Overwrite basis-80 class with basis-{size} for desired
// content width
// Replaces `conversation__questionContainer` and `conversation__component` styles
var ConvoPrompt = function (props) { return (React.createElement("div", { className: "mt-6 flex flex-row justify-end self-stretch" },
    React.createElement("div", { className: twMerge('flex basis-80 flex-col', props.className) }, props.children))); };
export default ConvoPrompt;
